import {
  type GetWorkerEventsForTierResponse,
  getWorkerEventsForTierResponseSchema,
} from "@clipboard-health/contract-worker-app-bff";
import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { type RatingType } from "@src/appV2/redesign/Tiers/utils/types";
import { useQuery, type UseQueryOptions, type UseQueryResult } from "@tanstack/react-query";

interface GetWorkerEventsForTierParams {
  workerId: string;
  rating: RatingType;
}

export function useGetWorkerEventsForTier(
  params: GetWorkerEventsForTierParams,
  options: UseQueryOptions<GetWorkerEventsForTierResponse> = {}
): UseQueryResult<GetWorkerEventsForTierResponse> {
  const { workerId, rating } = params;

  return useQuery<GetWorkerEventsForTierResponse>({
    queryKey: ["tier-worker-events", workerId, rating],
    queryFn: async () => {
      const { data } = await get({
        url: `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/workers/${workerId}/tiers/worker-events`,
        responseSchema: getWorkerEventsForTierResponseSchema,
        queryParams: { filter: { rating } },
      });
      return data;
    },
    ...options,
  });
}
